<template>
  <split-screen>
    <template v-slot:left>
      <div v-if="content" class="content pb-6">
        <span v-html="content[`visit_${lang}`]" />
      </div>
    </template>
    <template v-slot:right>
      <a href="https://www.google.com/maps/place/The+Centre+Pompidou/@48.8608662,2.350023,17z/data=!4m8!1m2!2m1!1sCentre+Pompidou+Place+Georges-Pompidou,+75004+Paris!3m4!1s0x47e66e1c09b820a3:0xb7ac6c7e59dc3345!8m2!3d48.860642!4d2.352245" target="_blank" class="fixed top-0 right-0 bottom-0 z-30 block w-1/2"></a><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1312.4373430568548!2d2.3512420108040963!3d48.86059994823548!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDjCsDUxJzM4LjIiTiAywrAyMScwNi42IkU!5e0!3m2!1sen!2sde!4v1569258288063!5m2!1sen!2sde" class="fixed w-1/2 h-full right-0 top-0 border-l border-black pb-12" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
    </template>
  </split-screen>
</template>

<script>
import { mapState } from 'vuex'
import SplitScreen from '@/views/SplitScreen'

export default {
  name: 'Visit',
  data () {
    return {
    }
  },
  components: {
    SplitScreen
  },
  computed: {
    ...mapState([
      'content',
      'lang'
    ])
  }
}
</script>

<style lang="stylus" scoped>
p, >>>p
  @apply mb-12

iframe
  margin-right: -1px
</style>
